import { useCurrency } from "@/lib/currency";

/**
 * Compact pill toggle to swap between ZAR and USD display prices.
 * Used above the pricing table and anywhere else prices are shown.
 */
export default function CurrencyToggle({ className = "" }) {
    const { currency, setCurrency } = useCurrency();

    return (
        <div
            data-testid="currency-toggle"
            role="radiogroup"
            aria-label="Display currency"
            className={`inline-flex p-1 rounded-full border border-zinc-200 bg-white shadow-sm ${className}`}
        >
            <button
                type="button"
                role="radio"
                aria-checked={currency === "ZAR"}
                data-testid="currency-toggle-zar"
                onClick={() => setCurrency("ZAR")}
                className={`px-4 py-1.5 text-sm font-semibold rounded-full transition-colors ${
                    currency === "ZAR" ? "bg-zinc-900 text-white" : "text-zinc-600 hover:text-zinc-900"
                }`}
            >
                <span className="mr-1" aria-hidden>🇿🇦</span> ZAR
            </button>
            <button
                type="button"
                role="radio"
                aria-checked={currency === "USD"}
                data-testid="currency-toggle-usd"
                onClick={() => setCurrency("USD")}
                className={`px-4 py-1.5 text-sm font-semibold rounded-full transition-colors ${
                    currency === "USD" ? "bg-zinc-900 text-white" : "text-zinc-600 hover:text-zinc-900"
                }`}
            >
                <span className="mr-1" aria-hidden>🌍</span> USD
            </button>
        </div>
    );
}
